import { useIntl } from "react-intl";
import { WmButton } from "@watermarkinsights/ripple-react";

export function ExportPanelHeader({
  onBack,
  onClose,
}: {
  onBack: () => void;
  onClose: () => void;
}) {
  const intl = useIntl();

  return (
    <div className="tcw-header-row">
      <WmButton
        button-type="navigational"
        icon="#back"
        className="tcw-back-btn"
        tooltip={intl.formatMessage({ id: "app.toolboxChat.action.back" })}
        onClick={onBack}
      />
      <div className="tcw-header-text">
        <div className="tcw-breadcrumb-row">
          <p className="tcw-breadcrumb">
            <button type="button" className="tcw-breadcrumb__link" onClick={onBack}>
              {intl.formatMessage({
                id: "app.toolboxChat.exportConversation.breadcrumbConversation",
              })}
            </button>
            <span className="tcw-breadcrumb__separator" aria-hidden="true">
              ›
            </span>
            <span className="tcw-breadcrumb__current" aria-current="step">
              {intl.formatMessage({
                id: "app.toolboxChat.exportConversation.breadcrumbExport",
              })}
            </span>
          </p>
        </div>
        <h2 className="tcw-header-title tcw-header-title--draft">
          {intl.formatMessage({ id: "app.toolboxChat.exportConversation.title" })}
        </h2>
      </div>
      <WmButton
        button-type="navigational"
        icon="#close"
        className="tcw-header-close-btn"
        tooltip={intl.formatMessage({ id: "app.toolboxChat.action.close" })}
        onClick={onClose}
      />
    </div>
  );
}
